import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  Tabs,
  Form,
  Row,
  Col,
  Select,
  Button,
  BackTop,
  Icon,
  Modal,
  Input,
  message,
  Spin,
  Radio,
  Checkbox
} from 'antd';
import { ImageStatus } from './filters/ImageStatus';
import { AgencyId } from './filters/AgencyId';
import { ImageId } from './filters/ImageId';
import { UsageUrl } from './filters/UsageUrl';
import { ImageUrl } from './filters/ImageUrl';
import {
  getDomainsByClickhouseUsageUrl,
  getDomainFlowStatuses,
  getCountriesList,
  changeUsageImagesData,
  getUsageUrlCount,
  changeClickhouseUsageImagesData,
  getDomainsByClickhouseArchiveUsageUrl
} from '../../redux/action/search/SearchActions';
import { getImagesTableAgencies } from '../../redux/action/common/CommonActions';
import { setBulkChanges } from '../../redux/action/finalReviewPage/finalReviewPage';
import {
  IMAGE_STATUSES,
  CLICKHOUSE_URL_TABLE_COLUMNS
} from './SearchPageConstants';
import UsageUrlTable from './components/UsageUrlTable';
import './SearchPage.css';
import { Country } from './filters/Country';
import { DifferenceFilter } from './filters/Difference';
import { FoundAtFilter } from './filters/FoundAt';
import { NonVerifiedCountry } from './filters/NonVerifiedCountry';
import { Domain } from './filters/Domain';

const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;

class SearchPage extends Component {
  constructor(props) {
    super(props);

    let selectedBlacklistedFilterOptions = {};
    let selectedImagesFilterOptions = {};
    let selectedFields = [];

    /* Set current tab from path */
    const { path } = this.props.match;
    const clickhouseUsageUrl = 'clickhouse_usage_url';
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    let defaultTab = 'images';
    let imageStatus = { order: '' };
    let agencyId = { order: '' };
    let imageId = { order: '' };
    let usageUrl = { order: '' };
    let imageUrl = { order: '' };
    let domain = { order: '' };
    let country = { order: '' };
    let scrapedCountry = { order: '' };
    let difference = { order: '' };
    let facebook = false;
    let facebookNotDefined = false;

    let imageStatusHouse = { order: '' };
    let agencyIdHouse = { order: '' };
    let imageIdHouse = { order: '' };
    let usageUrlHouse = { order: '' };
    let imageUrlHouse = { order: '' };
    let domainHouse = { order: '' };
    let countryHouse = { order: '' };
    let scrapedCountryHouse = { order: '' };
    let differenceHouse = { order: '' };

    if (path.includes(clickhouseUsageUrl)) {
      if (urlSearchParams.get('image_status')) {
        const statuses = urlSearchParams.get('image_status');
        imageStatusHouse['value'] = statuses.split(',');
      }

      if (urlSearchParams.get('agency')) {
        const agency = urlSearchParams.get('agency');
        agencyIdHouse['value'] = agency.split(',');
      }

      if (urlSearchParams.get('image_id')) {
        const id = urlSearchParams.get('image_id');
        imageIdHouse['value'] = id;
      }

      if (urlSearchParams.get('usage_url')) {
        const usage_url = urlSearchParams.get('usage_url');
        usageUrlHouse['value'] = usage_url;
      }

      if (urlSearchParams.get('image_url')) {
        const image_url = urlSearchParams.get('image_url');
        imageUrlHouse['value'] = image_url;
      }

      if (urlSearchParams.get('domain')) {
        const domainUrl = urlSearchParams.get('domain');
        domainHouse['value'] = domainUrl;
      }

      if (urlSearchParams.get('country')) {
        const countryValues = urlSearchParams.get('country');
        const countriesMap = countryValues
          .split(',')
          .filter((item) => item !== '');
        country['value'] = countriesMap;
      }

      if (urlSearchParams.get('non_verified_country')) {
        const scrapedCountryValues = urlSearchParams.get(
          'non_verified_country'
        );
        const countriesMap = scrapedCountryValues
          .split(',')
          .filter((item) => item !== '');
        country['value'] = countriesMap;
        scrapedCountry['value'] = countriesMap;
      }

      if (urlSearchParams.get('difference_max')) {
        const difference_max = urlSearchParams.get('difference_max');
        differenceHouse['differenceEnd'] = difference_max;
      }

      if (urlSearchParams.get('difference_min')) {
        const difference_min = urlSearchParams.get('difference_min');
        differenceHouse['differenceStart'] = difference_min;
      }

      if (urlSearchParams.get('facebook')) {
        const facebookValue = urlSearchParams.get('facebook');
        facebook = facebookValue;
      }

      if (urlSearchParams.get('facebook_not_defined')) {
        const facebook_not_defined = urlSearchParams.get(
          'facebook_not_defined'
        );
        facebookNotDefined = facebook_not_defined;
      }
    }

    this.state = {
      arciveSearch: false,
      copyright: false,
      copyrightClickhouse: false,
      imageIdExactSearch: false,
      selectedTabKey: 'images',
      loaderIsVisible: false,
      selectedDomainsFields: selectedFields,
      selectedImagesFilterOptions: selectedImagesFilterOptions,
      selectedBlacklistedFilterOptions: selectedBlacklistedFilterOptions,
      usageClickhouseUrlTableSortedOption: {},
      usageUrlPaginationOptions: {
        pageNumber: 1,
        pageSize: 1000
      },
      usageClickhouseUrlPaginationOptions: {
        pageNumber: 1,
        pageSize: 1000
      },
      usageClickhouseUrlSearchInput: '',
      imagesAgency: '',
      imagesAgencyId: '',
      selectedRowKeys: [],
      selectedImagesIds: [],
      sightingsFilters: {
        imageStatus: imageStatus,
        agencyId: agencyId,
        imageId: imageId,
        usageUrl: usageUrl,
        imageUrl: imageUrl,
        domain: domain,
        country: country,
        scrapedCountry: scrapedCountry,
        difference: difference,
        dates: { order: '' }
      },
      sightingsClickhouseFilters: {
        imageStatus: imageStatusHouse,
        agencyId: agencyIdHouse,
        imageId: imageIdHouse,
        usageUrl: usageUrlHouse,
        imageUrl: imageUrlHouse,
        domain: domainHouse,
        country: countryHouse,
        scrapedCountry: scrapedCountryHouse,
        difference: differenceHouse,
        dates: { order: '' }
      },
      usagesUrlSelectFilters: {
        pursuable: null,
        blacklisted: null
      },
      usagesClickhouseUrlSelectFilters: {
        pursuable: null,
        blacklisted: null
      },
      undefineCountry: false,
      undefineNonCountry: false,
      undefineCountryClickhouse: false,
      undefineNonCountryClickhouse: false,
      socialNetwork: false,
      facebook: facebook,
      exactMatches: false,
      exactMatchesClickhouse: false,
      visibleUsageError: false,
      facebookNotDefined: facebookNotDefined,
      clickhouseFacebook: false,
      clickhouseFacebookExcluded: false,
      domainExactMatch: false,
      notDelivered: false,
      ddomainExactMatch: false,
      defaultTabKey: defaultTab,
      radioCountryClickhouse: null,
      radioNonCountryClickhouse: null
    };
  }

  componentDidMount() {
    this.props.getImagesTableAgencies();
    this.props.getCountriesList();
    this.props.getDomainFlowStatuses();

    if (!this.props.userInfo.userPermissions?.tablePermission) {
      window.location = '/403';
    }

    const { path } = this.props.match;
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    if (path.includes('clickhouse_usage_url') && urlSearchParams.toString()) {
      this._autoSearchPending = true;
    }
  }

  componentDidUpdate(prevProps, state) {
    if (
      this._autoSearchPending &&
      this.props.getImagesTableAgenciesData !==
        prevProps.getImagesTableAgenciesData &&
      this.props.getImagesTableAgenciesData
    ) {
      this._autoSearchPending = false;
      setTimeout(() => {
        this.usageClickhouseUrlFormSubmit(null);
      }, 0);
    }
  }

  handleRouteTo = (path) => {
    window.location.pathname = path;
  };

  convertToBool = (str) => {
    if (str === 'true') return true;
    if (str === 'false') return false;
    if (str === 'all') return null;
  };

  handleApplyFilter = (mainType) => {
    // let requestData = {};
    let paginationOptions = {
      page: 0,
      size: 0
    };

    if (mainType === 'usageUrl') {
      this.props.form.validateFields((err, values) => {
        if (!err) {
          const { usageUrl, usageRadio } = values;
          const { sightingsFilters, usagesUrlSelectFilters } = this.state;

          const usageUrlPart = !_.isEmpty(sightingsFilters.usageUrl.value)
            ? sightingsFilters.usageUrl.value
            : null;

          const isNullBlacklised =
            _.isNull(usagesUrlSelectFilters.blacklisted) ||
            usagesUrlSelectFilters.blacklisted === 'null';

          const requestData = {
            part: usageRadio === 'usagePart' ? usageUrl : null,
            domainPart: usageRadio === 'usagePartDomain' ? usageUrl : null,
            sourcePart: usageRadio === 'usagePartSource' ? usageUrl : null,
            socialNetwork: this.state.socialNetwork,
            domainExactSearch: this.state.exactMatches,
            imageIdExactSearch: this.state.imageIdExactSearch,
            facebook: this.state.clickhouseFacebook
              ? true
              : this.state.clickhouseFacebookExcluded
              ? false
              : null,
            partForFilter: usageUrlPart,
            status: !_.isEmpty(sightingsFilters.imageStatus.value)
              ? [...sightingsFilters.imageStatus.value]
              : null,
            agency: !_.isEmpty(sightingsFilters.agencyId.value)
              ? [...sightingsFilters.agencyId.value]
              : null,
            imageId: !_.isEmpty(sightingsFilters.imageId.value)
              ? sightingsFilters.imageId.value
              : null,
            imageUrl: !_.isEmpty(sightingsFilters.imageUrl.value)
              ? sightingsFilters.imageUrl.value
              : null,
            domain: !_.isEmpty(sightingsFilters.domain.value)
              ? sightingsFilters.domain.value
              : null,
            pursuable: usagesUrlSelectFilters.pursuable,
            differenceStart: !_.isEmpty(
              sightingsFilters.difference?.differenceStart
            )
              ? sightingsFilters.difference?.differenceStart
              : null,
            differenceEnd: !_.isEmpty(
              sightingsFilters.difference?.differenceEnd
            )
              ? sightingsFilters.difference?.differenceEnd
              : null,
            foundAtStart: !_.isEmpty(sightingsFilters.dates.foundAtStart)
              ? sightingsFilters.dates.foundAtStart
              : null,
            foundAtEnd: !_.isEmpty(sightingsFilters.dates.foundAtEnd)
              ? sightingsFilters.dates.foundAtEnd
              : null,
            blacklisted: isNullBlacklised
              ? null
              : !this.convertToBool(usagesUrlSelectFilters.blacklisted),
            country: this.state.undefineCountry
              ? ['UNDEFINED']
              : !_.isEmpty(sightingsFilters.country.value)
              ? [...sightingsFilters.country.value]
              : null,
            scrapedCountry: this.state.undefineNonCountry
              ? ['UNDEFINED']
              : !_.isEmpty(sightingsFilters.scrapedCountry.value)
              ? [...sightingsFilters.scrapedCountry.value]
              : null,
            registeredImage: this.state.copyright
          };

          paginationOptions = {
            page: this.state.usageUrlPaginationOptions.pageNumber - 1,
            size: this.state.usageUrlPaginationOptions.pageSize
          };

          const sortingOptions = {
            status: sightingsFilters.imageStatus.order,
            agency: sightingsFilters.agencyId.order,
            imageId: sightingsFilters.imageId.order,
            imageUrl: sightingsFilters.imageUrl.order,
            domain: sightingsFilters.imageUrl.order,
            usageUrl: sightingsFilters.usageUrl.order,
            difference: sightingsFilters.difference.order
          };

          // if (!usageUrl || !usageRadio) {
          //   message.error('Search values can not be empty!');
          //   return;
          // }

          // if (usageUrl.trim().length < 3) {
          //   message.error('Search value should be at least 3 symbols!');
          //   return;
          // }

          this.setState({
            loaderIsVisible: true
          });
          this.props
            .getDomainsByUsageUrl(
              requestData,
              paginationOptions,
              sortingOptions
            )
            .then(() =>
              this.setState({
                loaderIsVisible: false
              })
            )
            .then(() => {
              if (!_.isEmpty(this.props.getDomainsByUsageUrlErrorMessage)) {
                message.error(
                  this.props.getDomainsByUsageUrlErrorMessage.error,
                  3
                );
              }
            });
        }
      });
    }
  };

  handleTablePaginationChange = (type, page, pageSize) => {
    let typeName = '';
    if (type === 'clickhouseUsageUrl') {
      typeName = 'usageClickhouseUrlPaginationOptions';
    }

    this.setState(
      {
        [typeName]: {
          pageNumber: page,
          pageSize: pageSize
        }
      },
      () => {
        this.handleApplyFilter(type);
      }
    );
  };

  handleColumnSortChange = (type, columnData) => {
    // let requestData = {};
    let paginationOptions = {
      page: 0,
      size: 10
    };
    let newSortingOption = {};
    let deleteSortOption = false;

    if (type === 'clickhouseUsageUrl') {
      paginationOptions = {
        page: this.state.usageClickhouseUrlPaginationOptions.pageNumber - 1,
        size: this.state.usageClickhouseUrlPaginationOptions.pageSize
      };

      if (
        this.state.usageClickhouseUrlTableSortedOption.hasOwnProperty(
          columnData.fieldKey
        )
      ) {
        let newSortType =
          this.state.usageClickhouseUrlTableSortedOption[columnData.fieldKey]
            .type === 'ASC'
            ? 'DESC'
            : '';
        if (
          this.state.usageClickhouseUrlTableSortedOption[columnData.fieldKey]
            .type === 'DESC'
        ) {
          deleteSortOption = true;
        }

        newSortingOption = {
          [columnData.fieldKey]: {
            type: newSortType
          }
        };
      } else {
        newSortingOption = {
          [columnData.fieldKey]: {
            type: 'ASC'
          }
        };
      }

      if (deleteSortOption) {
        newSortingOption = {};
      }

      this.props.form.validateFields((err, values) => {
        if (!err) {
          const { clickhouseUsageUrl, usageClickhouseRadio } = values;
          const {
            sightingsClickhouseFilters,
            usagesClickhouseUrlSelectFilters
          } = this.state;

          const usageUrlPart = !_.isEmpty(
            sightingsClickhouseFilters.usageUrl.value
          )
            ? sightingsClickhouseFilters.usageUrl.value
            : null;

          const isNullBlacklised =
            _.isNull(usagesClickhouseUrlSelectFilters.blacklisted) ||
            usagesClickhouseUrlSelectFilters.blacklisted === 'null';

          const requestData = {
            part:
              usageClickhouseRadio === 'usagePart' ? clickhouseUsageUrl : null,
            domainPart:
              usageClickhouseRadio === 'usagePartDomain'
                ? clickhouseUsageUrl
                : null,
            sourcePart:
              usageClickhouseRadio === 'usagePartSource'
                ? clickhouseUsageUrl
                : null,
            socialNetwork: this.state.socialNetwork,
            domainExactSearch: this.state.exactMatchesClickhouse,
            imageIdExactSearch: this.state.imageIdExactSearch,
            facebook: this.state.clickhouseFacebook
              ? true
              : this.state.clickhouseFacebookExcluded
              ? false
              : null,
            notDelivered: this.state.notDelivered
              ? this.state.notDelivered
              : null,
            partForFilter: usageUrlPart,
            status: !_.isEmpty(sightingsClickhouseFilters.imageStatus.value)
              ? [...sightingsClickhouseFilters.imageStatus.value]
              : null,
            agency: !_.isEmpty(sightingsClickhouseFilters.agencyId.value)
              ? [...sightingsClickhouseFilters.agencyId.value]
              : null,
            imageId: !_.isEmpty(sightingsClickhouseFilters.imageId.value)
              ? sightingsClickhouseFilters.imageId.value
              : null,
            imageUrl: !_.isEmpty(sightingsClickhouseFilters.imageUrl.value)
              ? sightingsClickhouseFilters.imageUrl.value
              : null,
            domain: !_.isEmpty(sightingsClickhouseFilters.domain.value)
              ? sightingsClickhouseFilters.domain.value
              : null,
            pursuable: usagesClickhouseUrlSelectFilters.pursuable,
            differenceStart: !_.isEmpty(
              sightingsClickhouseFilters.difference?.differenceStart
            )
              ? sightingsClickhouseFilters.difference?.differenceStart
              : null,
            differenceEnd: !_.isEmpty(
              sightingsClickhouseFilters.difference?.differenceEnd
            )
              ? sightingsClickhouseFilters.difference?.differenceEnd
              : null,
            foundAtStart: !_.isEmpty(
              sightingsClickhouseFilters.dates.foundAtStart
            )
              ? sightingsClickhouseFilters.dates.foundAtStart
              : null,
            foundAtEnd: !_.isEmpty(sightingsClickhouseFilters.dates.foundAtEnd)
              ? sightingsClickhouseFilters.dates.foundAtEnd
              : null,
            blacklisted: isNullBlacklised
              ? null
              : !this.convertToBool(
                  usagesClickhouseUrlSelectFilters.blacklisted
                ),
            country:
              this.state.radioCountryClickhouse === 'undefineCountryClickhouse'
                ? ['UNDEFINED']
                : this.state.radioCountryClickhouse === 'priority'
                ? (this.props.getCountriesListData || [])
                    .filter((c) => c.priority)
                    .map((c) => c.fullName)
                : !_.isEmpty(sightingsClickhouseFilters.country.value)
                ? [...sightingsClickhouseFilters.country.value]
                : null,
            scrapedCountry:
              this.state.radioNonCountryClickhouse ===
              'undefineNonCountryClickhouse'
                ? ['UNDEFINED']
                : this.state.radioNonCountryClickhouse === 'priority'
                ? (this.props.getCountriesListData || [])
                    .filter((c) => c.priority)
                    .map((c) => c.fullName)
                : !_.isEmpty(sightingsClickhouseFilters.scrapedCountry.value)
                ? [...sightingsClickhouseFilters.scrapedCountry.value]
                : null,
            registeredImage: this.state.copyrightClickhouse
          };

          this.setState(
            {
              loaderIsVisible: true,
              usageClickhouseUrlTableSortedOption: newSortingOption
            },
            () => {
              if (this.state.arciveSearch) {
                this.props
                  .getDomainsByClickhouseArchiveUsageUrl(
                    requestData,
                    paginationOptions,
                    newSortingOption
                  )
                  .then(() => {
                    if (
                      !_.isEmpty(
                        this.props.getDomainsByClickhouseUsageUrlErrorMessage
                      )
                    ) {
                      message.error(
                        this.props.getDomainsByClickhouseUsageUrlErrorMessage
                          .error,
                        3
                      );
                    } else {
                      this.setState({
                        loaderIsVisible: false
                      });
                    }
                  });
              } else {
                this.props
                  .getDomainsByClickhouseUsageUrl(
                    requestData,
                    paginationOptions,
                    newSortingOption
                  )
                  .then(() => {
                    if (
                      !_.isEmpty(
                        this.props.getDomainsByClickhouseUsageUrlErrorMessage
                      )
                    ) {
                      message.error(
                        this.props.getDomainsByClickhouseUsageUrlErrorMessage
                          .error,
                        3
                      );
                    } else {
                      this.setState({
                        loaderIsVisible: false
                      });
                    }
                  });
              }
            }
          );
        }
      });
    }
  };

  handleImageStatusChange = (value, imageData) => {
    const { setBulkChanges } = this.props;
    const { selectedImagesIds } = this.state;
    const ids = !_.isEmpty(selectedImagesIds)
      ? _.map(selectedImagesIds, (image) => image.id)
      : [imageData.id];

    this.setState({
      loaderIsVisible: true
    });

    Promise.resolve(
      setBulkChanges({
        ids,
        status: value
      })
    )
      .then(() => {
        this.props.changeUsageImagesData(ids, value);
        this.props.changeClickhouseUsageImagesData(ids, value);
      })
      .then(() => {
        this.setState({
          selectedImagesIds: [],
          selectedRowKeys: []
        });
      })
      .then(() =>
        this.setState({
          loaderIsVisible: false
        })
      );
  };

  renderImagesCountry = (domainData) => {
    return [this.renderImagesCellCountry(domainData)];
  };

  renderImagesNonCountry = (domainData) => {
    return [this.renderImagesCellNonCountry(domainData)];
  };

  renderImagesIcons = (value) => {
    return [this.renderImagesCellIcon(value)];
  };

  prepareUsageStatus = (imageData) => {
    return (
      <div
        className={`d-f-r-ac-jc ${imageData.status.toLowerCase()} ${
          !imageData.delivered ? 'delivered' : ''
        }`}
      >
        <div className='d-f-c-sb-center'>
          <Select
            style={{ width: 150, padding: '1rem 0' }}
            value={imageData.status}
            onChange={(value, option) => {
              this.handleImageStatusChange(value, imageData);
            }}
            disabled={imageData.delivered}
          >
            {_.map(Object.keys(IMAGE_STATUSES), (itemKey) => (
              <Option
                key={IMAGE_STATUSES[itemKey]}
                value={IMAGE_STATUSES[itemKey]}
              >
                {IMAGE_STATUSES[itemKey]}
              </Option>
            ))}
          </Select>
        </div>
      </div>
    );
  };

  renderImagePopover = (imageData, size, border = false) => {
    const imageLink = imageData && imageData.usageUrl;

    return (
      <div
        className='images-table-row'
        style={{ display: 'flex', justifyContent: 'space-around' }}
      >
        <div
          className='table-row__image'
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            flexDirection: 'column',
            alignItems: 'center',
            marginRight: 10
          }}
        >
          <span>Uploaded</span>
          <img
            className='popover-image-search'
            alt=''
            src={`${imageData.originalImageFileName}?introlab`}
            style={{ border: border ? '1px solid beige' : '' }}
          />
        </div>
        <div
          className='table-row__image'
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <a
            target='_blank'
            href={imageLink}
            rel='nofollow noopener noreferrer'
          >
            <span>Online</span>
            <img
              className='popover-image-search'
              alt=''
              src={imageData.imageUrl}
              style={{ border: border ? '1px solid beige' : '' }}
            />
          </a>
        </div>
      </div>
    );
  };

  prepareClickhouseUsageUrlTableData = () => {
    const { getDomainsByClickhouseUsageUrlData, getUsageUrlCountData } =
      this.props;

    let clonedTableData = _.cloneDeep(getDomainsByClickhouseUsageUrlData);
    clonedTableData.content = _.map(
      getDomainsByClickhouseUsageUrlData.content,
      (domainData) => {
        return _.merge({}, domainData, {
          scrapedCountry: this.renderImagesNonCountry(domainData),
          status: this.prepareUsageStatus(domainData),
          country: this.renderImagesCountry(domainData),
          imageUrl: this.renderImagePopover(domainData, true),
          pursuableIcon: this.renderImagesIcons(domainData.domainPursuable),
          blacklistedIcon: this.renderImagesIcons(domainData.blacklisted)
        });
      }
    );

    if (getUsageUrlCountData.count || getUsageUrlCountData.count === 0) {
      clonedTableData = _.merge({}, clonedTableData, {
        usageUrlCount: getUsageUrlCountData.count
      });
    } else {
      clonedTableData = _.merge({}, clonedTableData, {
        usageUrlCountStatic: 125
      });
    }

    return clonedTableData;
  };

  renderImagesCellCountry = (domainData) => {
    const country = domainData.country || null;

    if (country === null) {
      return '-';
    }

    if (Array.isArray(this.props.getCountriesListData)) {
      return this.props.getCountriesListData?.find(
        (obj) => obj.fullName.toLowerCase() === country.toLowerCase()
      );
    }

    return [];
  };

  renderImagesCellNonCountry = (domainData) => {
    const country = domainData.scrapedCountry || null;

    if (country === null) {
      return '-';
    }

    if (country !== null && country.indexOf('_') > -1) {
      const newArray = country.split('_');
      const newString = newArray.join(' ');

      if (Array.isArray(this.props.getCountriesListData)) {
        return this?.props.getCountriesListData?.find(
          (obj) => obj?.fullName.toLowerCase() === newString.toLowerCase()
        );
      }

      return [];
    }

    if (Array.isArray(this.props.getCountriesListData)) {
      return this.props?.getCountriesListData?.find(
        (obj) => obj?.fullName.toLowerCase() === country.toLowerCase()
      );
    }

    return [];
  };

  renderImagesCellIcon = (value) => {
    if (value === null) {
      return '-';
    }

    if (value === true) {
      return (
        <Icon style={{ color: 'green' }} type='check-circle' theme='filled' />
      );
    }

    if (value === false) {
      return (
        <Icon style={{ color: 'red' }} type='close-circle' theme='filled' />
      );
    }
  };

  usageClickhouseUrlSearchInputHandler = (e) => {
    this.setState({
      usageClickhouseUrlSearchInput: e.target.value
    });
  };

  /* @CLICKHOUSE SEARCH TAB ----------------------------------------------------------------------------------------------------------- */

  // Searh Function for Clickhouse Tab
  usageClickhouseUrlFormSubmit = (e, isResetRequest, filters) => {
    if (e) e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        let requestFunction = null;

        if (this.state.arciveSearch)
          requestFunction = this.props.getDomainsByClickhouseArchiveUsageUrl;
        else requestFunction = this.props.getDomainsByClickhouseUsageUrl;

        const { clickhouseUsageUrl, usageClickhouseRadio } = values;
        const { sightingsClickhouseFilters, usagesClickhouseUrlSelectFilters } =
          this.state;

        let currentFilters = isResetRequest
          ? filters
          : sightingsClickhouseFilters;

        let paginationOptions = {
          page: 0,
          size: this.state.usageUrlPaginationOptions.pageSize
        };

        const usageUrlPart = !_.isEmpty(currentFilters.usageUrl.value)
          ? currentFilters.usageUrl.value
          : null;

        const isNullBlacklised =
          _.isNull(usagesClickhouseUrlSelectFilters.blacklisted) ||
          usagesClickhouseUrlSelectFilters.blacklisted === 'null';

        const requestData = {
          part:
            usageClickhouseRadio === 'usagePart' ? clickhouseUsageUrl : null,
          domainPart:
            usageClickhouseRadio === 'usagePartDomain'
              ? clickhouseUsageUrl
              : null,
          sourcePart:
            usageClickhouseRadio === 'usagePartSource'
              ? clickhouseUsageUrl
              : null,
          socialNetwork: this.state.socialNetwork,
          domainExactSearch: this.state.exactMatchesClickhouse,
          imageIdExactSearch: this.state.imageIdExactSearch,
          facebook: this.state.clickhouseFacebook
            ? true
            : this.state.clickhouseFacebookExcluded
            ? false
            : null,
          notDelivered: this.state.notDelivered
            ? this.state.notDelivered
            : null,
          partForFilter: usageUrlPart,
          status: !_.isEmpty(currentFilters.imageStatus.value)
            ? [...currentFilters.imageStatus.value]
            : null,
          agency: !_.isEmpty(currentFilters.agencyId.value)
            ? [...currentFilters.agencyId.value]
            : null,
          imageId: !_.isEmpty(currentFilters.imageId.value)
            ? currentFilters.imageId.value
            : null,
          imageUrl: !_.isEmpty(currentFilters.imageUrl.value)
            ? currentFilters.imageUrl.value
            : null,
          domain: !_.isEmpty(currentFilters.domain.value)
            ? currentFilters.domain.value
            : null,
          pursuable: usagesClickhouseUrlSelectFilters.pursuable,
          differenceStart: !_.isEmpty(
            currentFilters.difference?.differenceStart
          )
            ? currentFilters.difference?.differenceStart
            : null,
          differenceEnd: !_.isEmpty(currentFilters.difference?.differenceEnd)
            ? currentFilters.difference?.differenceEnd
            : null,
          foundAtStart: !_.isEmpty(currentFilters.dates.foundAtStart)
            ? currentFilters.dates.foundAtStart
            : null,
          foundAtEnd: !_.isEmpty(currentFilters.dates.foundAtEnd)
            ? currentFilters.dates.foundAtEnd
            : null,
          blacklisted: isNullBlacklised
            ? null
            : !this.convertToBool(usagesClickhouseUrlSelectFilters.blacklisted),
          country:
            this.state.radioCountryClickhouse === 'undefineCountryClickhouse'
              ? ['UNDEFINED']
              : this.state.radioCountryClickhouse === 'priority'
              ? (this.props.getCountriesListData || [])
                  .filter((c) => c.priority)
                  .map((c) => c.fullName)
              : !_.isEmpty(currentFilters.country.value)
              ? [...currentFilters.country.value]
              : null,
          scrapedCountry:
            this.state.radioNonCountryClickhouse ===
            'undefineNonCountryClickhouse'
              ? ['UNDEFINED']
              : this.state.radioNonCountryClickhouse === 'priority'
              ? (this.props.getCountriesListData || [])
                  .filter((c) => c.priority)
                  .map((c) => c.fullName)
              : !_.isEmpty(currentFilters.scrapedCountry.value)
              ? [...currentFilters.scrapedCountry.value]
              : null,
          registeredImage: this.state.copyrightClickhouse
        };

        const sortingOptions = {
          status: currentFilters.imageStatus.order,
          agency: currentFilters.agencyId.order,
          imageId: currentFilters.imageId.order,
          imageUrl: currentFilters.imageUrl.order,
          domain: currentFilters.domain.order,
          usageUrl: currentFilters.usageUrl.order,
          country: currentFilters.country.order,
          scrapedCountry: currentFilters.scrapedCountry.order,
          difference: currentFilters.difference.order,
          // foundAt: sightingsFilters.dates.order
          foundAt: currentFilters.dates.order
            ? currentFilters.dates.order
            : 'desc'
        };

        this.setState({
          loaderIsVisible: true,
          usageClickhouseUrlPaginationOptions: {
            pageNumber: 1,
            pageSize: 1000
          }
        });

        Promise.resolve(
          requestFunction(requestData, paginationOptions, sortingOptions)
        )
          .then(() => {
            this.setState({ loaderIsVisible: false });
          })
          .then(() => {
            if (this.props.getDomainsByClickhouseUsageUrlErrorMessage) {
              this.setState({ visibleUsageError: true });
            }

            if (this.props.getDomainsByClickhouseUsageUrlData?.countId) {
              this.props.getUsageUrlCount(
                this.props.getDomainsByClickhouseUsageUrlData?.countId
              );
              const timer = setInterval(() => {
                if (!this.props.getUsageUrlCountData.count) {
                  this.props.getUsageUrlCount(
                    this.props.getDomainsByClickhouseUsageUrlData.countId
                  );
                } else {
                  clearInterval(timer);
                }
              }, 5000);
            }
          });
      }
    });
  };

  // Reset For Clickhouse
  resetClickhouseSightingsFilter = () => {
    const resetFilters = {
      sightingsClickhouseFilters: {
        imageStatus: { order: '' },
        agencyId: { order: '' },
        imageId: { order: '' },
        usageUrl: { order: '' },
        imageUrl: { order: '' },
        domain: { order: '' },
        country: { order: '' },
        scrapedCountry: { order: '' },
        difference: { order: '' },
        scrappedCountries: { order: '' },
        dates: { order: '' }
      },
      usagesClickhouseUrlSelectFilters: {
        pursuable: null,
        blacklisted: null
      }
    };

    this.setState(resetFilters);

    this.usageClickhouseUrlFormSubmit(
      null,
      true,
      resetFilters.sightingsClickhouseFilters
    );
  };

  /* --------------------------------------------------------------------------------------------------------------------------------- */

  autoSize = (e) => {
    const el = e.target;
    setTimeout(() => {
      el.style.cssText = 'height:32px; padding:0';
      el.style.cssText = 'height:' + el.scrollHeight + 'px';
    }, 0);
  };

  onSelectChange = (selectedRowKeys, row) => {
    this.setState({
      selectedImagesIds: row,
      selectedRowKeys
    });
  };

  onUsageUrlErrorClose = () => {
    this.setState({ visibleUsageError: false });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange
    };
    const antIcon = <Icon type='loading' style={{ fontSize: 24 }} spin />;

    return (
      <Spin size='large' spinning={this.state.loaderIsVisible}>
        <Modal
          visible={this.state.visibleUsageError}
          onOk={this.onUsageUrlErrorClose}
          onCancel={() => {}}
          okButtonProps={{
            children: 'OK'
          }}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <p>{this.props.getDomainsByUsageUrlErrorMessage}</p>
        </Modal>

        <div className='Search ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
          <BackTop>
            <div className='ant-back-top-inner'>
              <Icon type='vertical-align-top' />
            </div>
          </BackTop>
          <Tabs defaultActiveKey={this.state.defaultTabKey}>
            {/*  Clickhouse Tab */}
            {this.props.userInfo.userPermissions?.tablePermission && (
              <TabPane tab='Clickhouse Usage url' key='clickhouseUsageUrl'>
                {/* <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-25'> */}
                <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-10'>
                  <Form onSubmit={this.usageClickhouseUrlFormSubmit}>
                    <Row
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: '.5rem'
                      }}
                    >
                      <Col
                        style={{
                          width: '45%',
                          marginRight: '10px'
                        }}
                      >
                        <Form.Item style={{ marginBottom: 0 }}>
                          {getFieldDecorator('clickhouseUsageUrl')(
                            <TextArea
                              style={{ height: '32px', overflow: 'hidden' }}
                              rows={2}
                              placeholder='Please enter usage url'
                              onChange={
                                this.usageClickhouseUrlSearchInputHandler
                              }
                              onKeyDown={this.autoSize}
                            ></TextArea>
                          )}
                        </Form.Item>
                      </Col>
                      <Col
                        style={{
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Form.Item
                          style={{
                            marginBottom: 0,
                            marginRight: '1rem'
                          }}
                        >
                          <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-4 ant-col-xl-4'>
                            <Button type='primary' htmlType='submit'>
                              Search
                            </Button>
                          </div>
                        </Form.Item>

                        {this.props.getUsageUrlCountData.hasOwnProperty(
                          'count'
                        ) &&
                          this.props.getUsageUrlCountData.count === null && (
                            <>
                              <span style={{ marginRight: '1rem' }}>Total</span>
                              <Spin indicator={antIcon} />
                            </>
                          )}

                        {this.props.getUsageUrlCountData.hasOwnProperty(
                          'count'
                        ) &&
                          this.props.getUsageUrlCountData.count > -1 &&
                          this.props.getDomainsByClickhouseUsageUrlData.count >
                            0 && (
                            <span>
                              Total{' '}
                              <b>{this.props.getUsageUrlCountData.count}</b>{' '}
                              {this.props.getUsageUrlCountData.count > 1
                                ? 'items'
                                : 'item'}
                            </span>
                          )}
                      </Col>
                    </Row>
                    <Row
                      style={{
                        display: 'flex',
                        marginBottom: '1rem',
                        width: '50%',
                        alignItems: 'center'
                      }}
                    >
                      <Form.Item style={{ marginBottom: 0 }}>
                        {getFieldDecorator('usageClickhouseRadio', {
                          initialValue: 'usagePart'
                        })(
                          <Radio.Group>
                            <Radio
                              value='usagePart'
                              style={{ marginRight: '1rem' }}
                            >
                              All
                            </Radio>
                            <Radio
                              value='usagePartDomain'
                              style={{ marginRight: '1rem' }}
                            >
                              Within domain
                            </Radio>
                            <Radio
                              value='usagePartSource'
                              style={{ marginRight: '1rem' }}
                            >
                              Without domain
                            </Radio>
                          </Radio.Group>
                        )}
                      </Form.Item>

                      <div style={{ marginLeft: 'auto' }}>
                        <Checkbox
                          onChange={(e) => {
                            if (e.target.checked) {
                              this.setState({ arciveSearch: true });
                            } else {
                              this.setState({ arciveSearch: false });
                            }
                          }}
                          checked={this.state.arciveSearch}
                        >
                          Search in archive
                        </Checkbox>

                        <Checkbox
                          onChange={(e) => {
                            if (e.target.checked) {
                              this.setState({ clickhouseFacebook: true });
                            } else {
                              this.setState({ clickhouseFacebook: false });
                            }
                          }}
                          checked={this.state.clickhouseFacebook}
                        >
                          Facebook
                        </Checkbox>

                        <Checkbox
                          onChange={(e) => {
                            if (e.target.checked) {
                              this.setState({
                                clickhouseFacebookExcluded: true,
                                clickhouseFacebook: false
                              });
                            } else {
                              this.setState({
                                clickhouseFacebookExcluded: false
                              });
                            }
                          }}
                          checked={this.state.clickhouseFacebookExcluded}
                        >
                          Facebook excluded
                        </Checkbox>

                        <Checkbox
                          onChange={(e) => {
                            if (e.target.checked) {
                              this.setState({
                                notDelivered: true
                              });
                            } else {
                              this.setState({
                                notDelivered: false
                              });
                            }
                          }}
                          checked={this.state.notDelivered}
                        >
                          Not delivered
                        </Checkbox>
                      </div>
                    </Row>
                  </Form>
                </div>
                <div className='search-tab-usages ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
                  <Row
                    style={{
                      paddingTop: '2rem'
                    }}
                  >
                    <div className='ant-col-xs-24'>
                      <div className='filter-fields'>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%'
                          }}
                        >
                          <Button
                            type='primary'
                            onClick={() =>
                              this.resetClickhouseSightingsFilter()
                            }
                            style={{ width: '84px' }}
                          >
                            Reset
                          </Button>
                          <ImageStatus
                            params={
                              this.state.sightingsClickhouseFilters.imageStatus
                            }
                            statuses={Object.values(IMAGE_STATUSES)}
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  imageStatus: filter
                                }
                              })
                            }
                          />
                          <AgencyId
                            params={
                              this.state.sightingsClickhouseFilters.agencyId
                            }
                            agencies={this.props.getImagesTableAgenciesData}
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  agencyId: filter
                                }
                              })
                            }
                            setIsCopyright={(state) =>
                              this.setState({
                                copyrightClickhouse: state
                              })
                            }
                            isCopyright={this.state.copyrightClickhouse}
                          />
                          <Country
                            params={
                              this.state.sightingsClickhouseFilters.country
                            }
                            countries={this.props.getCountriesListData}
                            radioValue={this.state.radioCountryClickhouse}
                            onChangeDefine={(e) => {
                              if (!e) {
                                this.setState({ radioCountryClickhouse: null });
                                return;
                              }
                              const val = e.target.value;
                              this.setState({
                                radioCountryClickhouse:
                                  val === this.state.radioCountryClickhouse
                                    ? null
                                    : val
                              });
                            }}
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  country: filter
                                }
                              })
                            }
                          />
                          <NonVerifiedCountry
                            params={
                              this.state.sightingsClickhouseFilters
                                .scrapedCountry
                            }
                            countries={this.props.getCountriesListData}
                            radioValue={this.state.radioNonCountryClickhouse}
                            onChangeDefine={(e) => {
                              if (!e) {
                                this.setState({
                                  radioNonCountryClickhouse: null
                                });
                                return;
                              }
                              const val = e.target.value;
                              this.setState({
                                radioNonCountryClickhouse:
                                  val === this.state.radioNonCountryClickhouse
                                    ? null
                                    : val
                              });
                            }}
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  scrapedCountry: filter
                                }
                              })
                            }
                          />
                          <ImageId
                            params={
                              this.state.sightingsClickhouseFilters.imageId
                            }
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  imageId: filter
                                }
                              })
                            }
                            hasExactMatch
                            setIsExactMatch={(state) =>
                              this.setState({
                                imageIdExactSearch: state
                              })
                            }
                            isExactMatch={this.state.imageIdExactSearch}
                          />
                          <ImageUrl
                            params={
                              this.state.sightingsClickhouseFilters.imageUrl
                            }
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  imageUrl: filter
                                }
                              })
                            }
                          />
                          <Domain
                            params={
                              this.state.sightingsClickhouseFilters.domain
                            }
                            exact={this.state.exactMatchesClickhouse}
                            onChangeExact={(state) =>
                              this.setState({
                                exactMatchesClickhouse: state
                              })
                            }
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  domain: filter
                                }
                              })
                            }
                          />
                          <UsageUrl
                            params={
                              this.state.sightingsClickhouseFilters.usageUrl
                            }
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  usageUrl: filter
                                }
                              })
                            }
                          />
                          <FoundAtFilter
                            params={this.state.sightingsClickhouseFilters.dates}
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  dates: filter
                                }
                              })
                            }
                          />
                          <DifferenceFilter
                            params={
                              this.state.sightingsClickhouseFilters.difference
                            }
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  difference: filter
                                }
                              })
                            }
                          />
                          <div
                            style={{
                              width: '4%',
                              padding: '0 3px'
                            }}
                          >
                            <Form.Item>
                              <Select
                                style={{
                                  width: '100%'
                                }}
                                defaultValue='null'
                                value={String(
                                  this.state.usagesClickhouseUrlSelectFilters
                                    .pursuable
                                )}
                                onChange={(value) =>
                                  this.setState({
                                    usagesClickhouseUrlSelectFilters: {
                                      ...this.state
                                        .usagesClickhouseUrlSelectFilters,
                                      pursuable: value
                                    }
                                  })
                                }
                              >
                                <Option key='all' value='null'>
                                  All
                                </Option>
                                <Option key='true' value='true'>
                                  True
                                </Option>
                                <Option key='false' value='false'>
                                  False
                                </Option>
                              </Select>
                            </Form.Item>
                          </div>
                          <div
                            style={{
                              width: '4%',
                              paddingRight: '6px',
                              paddingLeft: '3px'
                            }}
                          >
                            <Form.Item>
                              <Select
                                style={{
                                  width: '100%'
                                }}
                                defaultValue='null'
                                value={String(
                                  this.state.usagesClickhouseUrlSelectFilters
                                    .blacklisted
                                )}
                                onChange={(value) =>
                                  this.setState({
                                    usagesClickhouseUrlSelectFilters: {
                                      ...this.state
                                        .usagesClickhouseUrlSelectFilters,
                                      blacklisted: value
                                    }
                                  })
                                }
                              >
                                <Option key='all' value='null'>
                                  All
                                </Option>
                                <Option key='true' value='false'>
                                  True
                                </Option>
                                <Option key='false' value='true'>
                                  False
                                </Option>
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Row>
                  {this.props.getDomainsByClickhouseUsageUrlData?.hasOwnProperty(
                    'content'
                  ) && (
                    <UsageUrlTable
                      noDataMsg='No data for this domain'
                      tableFor='clickhouseUsageUrl'
                      tableColumns={CLICKHOUSE_URL_TABLE_COLUMNS}
                      tableData={this.prepareClickhouseUsageUrlTableData()}
                      paginationOptions={
                        this.state.usageClickhouseUrlPaginationOptions
                      }
                      selectedFiltersFields={this.state.selectedDomainsFields}
                      onChangePagination={this.handleTablePaginationChange}
                      handleChangeColumnSort={this.handleColumnSortChange}
                      sortingOptions={
                        this.state.usageClickhouseUrlTableSortedOption
                      }
                      redirectPermission={
                        this.props.userInfo.userPermissions?.reviewPermission
                      }
                      rowSelection={rowSelection}
                    />
                  )}
                </div>
              </TabPane>
            )}
          </Tabs>
        </div>
      </Spin>
    );
  }
}

function mapStateToProps({ auth, searchStore, commonStore, qc_frStore }) {
  return {
    userInfo: auth.userInfo,
    getDomainsByClickhouseUsageUrlData:
      searchStore.getDomainsByClickhouseUsageUrlData,
    getDomainsByUsageUrlErrorMessage:
      searchStore.getDomainsByUsageUrlErrorMessage,
    getDomainsByClickhouseUsageUrlErrorMessage:
      searchStore.getDomainsByClickhouseUsageUrlErrorMessage,
    getImagesTableAgenciesData: commonStore.getImagesTableAgenciesData,
    getCountriesListData: searchStore.getCountriesListData,
    getUsageUrlCountData: searchStore.getUsageUrlCountData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDomainsByClickhouseUsageUrl: bindActionCreators(
      getDomainsByClickhouseUsageUrl,
      dispatch
    ),
    getDomainsByClickhouseArchiveUsageUrl: bindActionCreators(
      getDomainsByClickhouseArchiveUsageUrl,
      dispatch
    ),
    getImagesTableAgencies: bindActionCreators(
      getImagesTableAgencies,
      dispatch
    ),
    getDomainFlowStatuses: bindActionCreators(getDomainFlowStatuses, dispatch),
    getCountriesList: bindActionCreators(getCountriesList, dispatch),
    changeUsageImagesData: bindActionCreators(changeUsageImagesData, dispatch),
    changeClickhouseUsageImagesData: bindActionCreators(
      changeClickhouseUsageImagesData,
      dispatch
    ),
    setBulkChanges: bindActionCreators(setBulkChanges, dispatch),
    getUsageUrlCount: bindActionCreators(getUsageUrlCount, dispatch)
  };
}

// export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create({ name: 'SearchPage' })(SearchPage));
